const IdpDestroySessionResponse = function(samlResponse) {
  this.samlResponse = samlResponse
}

IdpDestroySessionResponse.prototype = Object.create(Error.prototype)
IdpDestroySessionResponse.prototype.constructor = IdpDestroySessionResponse

export default IdpDestroySessionResponse


/** WEBPACK FOOTER **
 ** ./components/identity-provider/idp-destroy-session-response.js
 **/